// Transport unique vers l'API : le cookie de session est toujours envoyé et
// chaque écriture porte le jeton CSRF lié à cette session. Importé en premier
// dans index.js pour couvrir tous les modules existants sans les réécrire.
import { epochActuel } from './demarrage';

const BASE = process.env.REACT_APP_BACKEND_URL ?? '';
const SURES = ['GET', 'HEAD', 'OPTIONS'];

export const jetonCsrf = () =>
  decodeURIComponent(
    document.cookie.split('; ').find((c) => c.startsWith('erp_csrf='))?.split('=')[1] ?? ''
  );

const brut = window.fetch.bind(window);

window.fetch = (entree, options = {}) => {
  const url = typeof entree === 'string' ? entree : (entree?.url ?? '');
  const versApi = url.startsWith(`${BASE}/api`) || url.startsWith('/api');
  if (!versApi) return brut(entree, options);
  const headers = new Headers(options.headers || {});
  const methode = (options.method || 'GET').toUpperCase();
  if (!SURES.includes(methode)) {
    headers.set('X-CSRF-Token', jetonCsrf());
    // Jeu de données : une saisie préparée avant une remise à zéro est refusée
    // par le serveur au lieu d'écraser les données neuves.
    const epoch = epochActuel();
    if (epoch) headers.set('X-Donnees-Epoch', epoch);
  }
  return brut(entree, { ...options, credentials: 'include', headers });
};
